<div style="padding-top: 10px; height:100%;">
    <div *ngIf='gene_hits_table'>
        <grid [data]="gene_hits_table"></grid>
    </div>
</div>
<!-- <ngx-monaco-editor class="my-code-editor" [(ngModel)]="code" [options]="editorOptions" (onInit)="onInit($event)" #editor>
</ngx-monaco-editor> -->